import React, { Component } from 'react';

export default class Contact extends Component{


    render(){
        
        return(
            <section>
                <h1>Contact</h1>
            </section>
        )
    }
}